import { render, staticRenderFns } from "./BlockTickets.vue?vue&type=template&id=33c2c044&scoped=true"
import script from "./BlockTickets.vue?vue&type=script&lang=js"
export * from "./BlockTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2c044",
  null
  
)

export default component.exports